<div class="modal-wrapper">
  <div class="modal-header">
    <h2 class="h6_500 modal-title" mat-dialog-title>
      {{ title | translate }}
    </h2>
    <button mat-icon-button class="modal-close-button" (click)="onEventClose()" aria-label="Close" [disableRipple]="true">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="modal-content">
    <form [formGroup]="form" class="modal-form">
      <app-text-area-field
        [control]="textControl"
        [widthLayout]="'fill'"
        [label]="(inputLabel | translate)"
        [placeholder]="placeholder ? (placeholder | translate) : (inputLabel | translate)"
        [minHeightPx]="minHeightPx"
        [valueFormat]="valueFormat"
        [maxCharacters]="maxCharacters"
        [disabled]="loading"
      ></app-text-area-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions">
    <common-buttons-outlined
      [label]="labelButtonCancel | translate"
      [disabled]="loading"
      [iconPosition]="false"
      (output)="onEventCancel()"
    ></common-buttons-outlined>

    <common-buttons-filled
      [label]="labelButtonSave | translate"
      [disabled]="loading || !form.valid"
      [iconPosition]="false"
      (output)="onEventSave()"
    ></common-buttons-filled>
  </mat-dialog-actions>
</div>

